import { useSimpleId } from '../common/hooks.js';
import React, { forwardRef, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FormContext } from '../Form/FormContext.js';
import { FormRowContext } from '../FormRow/FormRowContext.js';
import { SelectStyles } from './Select.styles.js';

const defaultProps = {
    alternative: false,
    error: false,
    rounding: 'sharp',
    sizing: 'medium',
};
const _Select = forwardRef(({ alternative, // Used only in styling, prevent passing it to DOM
children, className, error, // Used only in styling, prevent passing it to DOM
id: propId, rounding, // Used only in styling, prevent passing it to DOM
sizing, // Used only in styling, prevent passing it to DOM
...rest }, ref) => {
    const formRowContext = useContext(FormRowContext);
    const id = propId !== null && propId !== void 0 ? propId : useSimpleId();
    useEffect(() => {
        formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.register({ id });
    }, [id]);
    return (React.createElement("select", { ...rest, className: className, id: id, ref: ref }, children));
});
_Select.displayName = '_Select';
const Select = styled(_Select).attrs((props) => {
    var _a, _b, _c, _d, _e, _f;
    const { alternative, rounding, sizing } = props;
    const formContext = useContext(FormContext);
    const formRowContext = useContext(FormRowContext);
    const modifiedProps = {
        alternative: (_b = (_a = alternative !== null && alternative !== void 0 ? alternative : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.alternative) !== null && _a !== void 0 ? _a : formContext === null || formContext === void 0 ? void 0 : formContext.alternative) !== null && _b !== void 0 ? _b : defaultProps.alternative,
        sizing: (_d = (_c = sizing !== null && sizing !== void 0 ? sizing : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.sizing) !== null && _c !== void 0 ? _c : formContext === null || formContext === void 0 ? void 0 : formContext.sizing) !== null && _d !== void 0 ? _d : defaultProps.sizing,
        rounding: (_f = (_e = rounding !== null && rounding !== void 0 ? rounding : formRowContext === null || formRowContext === void 0 ? void 0 : formRowContext.rounding) !== null && _e !== void 0 ? _e : formContext === null || formContext === void 0 ? void 0 : formContext.rounding) !== null && _f !== void 0 ? _f : defaultProps.rounding,
    };
    return modifiedProps;
}) `
    ${SelectStyles}
`;

export { Select, defaultProps };
//# sourceMappingURL=Select.js.map
